/* eslint-disable */
import { Breadcrumbs, Typography, Tooltip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.scss';

const Breadcrumb = (props) => {
	const { breadcrumbs, truncate = false } = props;

	const renderName = (name) => {
		if (truncate && name?.length > 30) {
			return (
				<Tooltip title={name} placement='bottom-start'>
					<span>{`${name.substring(0, 20)}...`}</span>
				</Tooltip>
			);
		}
		return name;
	};

	return (
		<div>
			<Breadcrumbs
				separator={<NavigateNextIcon fontSize='small' />}
				aria-label='breadcrumb'
			>
				{breadcrumbs.map((currentBreadcrumb) => {
					if (currentBreadcrumb.link) {
						return (
							<Link
								className={styles.link}
								to={currentBreadcrumb.link}
							>
								{renderName(currentBreadcrumb.name)}
							</Link>
						);
					}
					return (
						<Typography key='3' color='text.primary' variant='h6'>
							{renderName(currentBreadcrumb.name)}
						</Typography>
					);
				})}
			</Breadcrumbs>
		</div>
	);
};

export default Breadcrumb;
